// What the form says of each field (TX-US-0043): required, when a save needs it; needed, when the
// next move waits on it; and locked, when an approved round agreed it. Pure, so every stage is
// tested without a screen. Fields are named as the API names them (trex/deals/fields.py).

import { requiredFields } from './dealForm.js';

// trex/deals/terms.py LOCKED_TERMS
export const LOCKED_TERMS = [
  'direction',
  'counterparty',
  'product',
  'quantity',
  'quantity_tolerance_pct',
  'price',
  'incoterms',
  'named_place',
  'payment_terms',
  'delivery_period',
];

// The keys of trex/deals/gates.py that name a field: the submission's, each the field's own name. A
// document is not a field, and the counterparty's approval is its onboarding's, not the deal's -
// the box beside the fields lists both.
const FIELD_GATE_KEYS = new Set([
  'quantity',
  'price',
  'named_place',
  'payment_terms',
  'delivery_period',
  'counterparty',
]);

// The form's marks (DealForm.jsx): what a save requires, and nothing the flow says.
export const formMarks = (context) => ({
  required: new Set(requiredFields(context)),
  needed: new Set(),
  locked: new Set(),
});

const approvedRound = (approval) => approval?.commercial?.decision === 'APPROVED'
  && approval?.risk?.decision === 'APPROVED';

// The terms an approved round locks, as trex/deals/terms.py locked_changes decides: at Contract
// and Execution, once the round on the deal is approved. A deal entered before the flow holds no
// round, so nothing on it is locked.
export function lockedTerms(deal) {
  const locked = ['CONTRACT', 'EXECUTION'].includes(deal.stage) && approvedRound(deal.approval);
  return new Set(locked ? LOCKED_TERMS : []);
}

// The fields the next move waits on and does not have, from the API's own `next_move.needed`. Only
// a submission waits on fields: Contract and Execution wait on documents and the counterparty.
export function neededFields(deal, view) {
  if (deal.stage !== 'PROPOSAL') return new Set();
  return new Set(
    (view?.next_move?.needed ?? [])
      .filter((item) => !item.present && FIELD_GATE_KEYS.has(item.key))
      .map((item) => item.key),
  );
}

// The deal page's marks, with the flow on.
export const fieldMarks = (deal, view) => ({
  required: new Set(requiredFields({ flow: true, stage: deal.stage })),
  needed: neededFields(deal, view),
  locked: lockedTerms(deal),
});
